import React from 'react';
import { CTAButton } from './CTAButton';
export function AboutSection() {
  return <section className="w-full bg-cream-200 py-14 sm:py-20" data-id="element-20" data-mp="2lcg8bx1efywc">
      <div className="mx-auto w-full max-w-4xl px-4 sm:px-6" data-id="element-21" data-mp="2lcyfhoplnxj1">
        <p className="text-center text-[11px] font-bold uppercase tracking-[0.16em] text-gold-600" data-id="element-22" data-mp="2gc2af7tii5c1">
          🦷 About Dr. Karito
        </p>

        <div className="mt-7 grid gap-6 md:grid-cols-[minmax(0,0.85fr)_minmax(0,1.15fr)] md:items-start md:gap-8" data-id="element-23" data-mp="2bg3e8y1xzj12">
          <figure className="overflow-hidden rounded-3xl border border-navy-900/10 bg-white shadow-lift" data-id="element-24" data-mp="22lp1p38sqmln">
            <img src="https://cdn.magicpatterns.com/uploads/4w5E7PgSvYZv98yQZbVN9P/Dra._Karito_Odontologa.png" alt="Dr. Karito, dentist and creator of the Occlusion 360 system, in her clinic" className="block w-full object-cover" width={944} height={1680} loading="lazy" data-id="element-25" data-mp="1xmcgso1hjplp" />
            <figcaption className="border-t border-navy-900/10 px-4 py-3 text-center" data-id="element-26" data-mp="1joxn37478vnx">
              <span className="block font-display text-lg font-bold text-navy-900" data-id="element-27" data-mp="sqrple86u0kh">
                Dr. Karito
              </span>
              <span className="block text-[12px] font-semibold uppercase tracking-[0.12em] text-gold-600" data-id="element-28" data-mp="itwtf1ze0c9d">
                Creator of Occlusion 360™
              </span>
            </figcaption>
          </figure>

          <div data-id="element-29" data-mp="1biu007u8kkma">
            <h2 className="font-display text-[24px] font-bold leading-tight text-navy-900 sm:text-3xl" data-id="element-30" data-mp="1biasll27pemi">
              The real challenge wasn’t a lack of knowledge — it was the{' '}
              <em className="not-italic text-gold-600" data-id="element-31" data-mp="12i5s7uvfrghu">lack of a system</em>.
            </h2>

            <div className="mt-5 space-y-4 text-[14.5px] leading-relaxed text-navy-700/85" data-id="element-32" data-mp="16j7mdxahx2cy">
              <p data-id="element-33" data-mp="3n84rlfyf0h8u">
                For years, Dr. Karito worked with patients while facing the same
                challenge experienced by thousands of dentists: increasingly
                complex cases and critical clinical decisions that could influence
                the final result.
              </p>
              <p data-id="element-34" data-mp="1srczxchxttxc">
                Over time, she recognized that the real challenge wasn’t simply a
                lack of knowledge. It was the lack of a clear system for organizing
                clinical decisions. That insight led to the creation of Occlusion
                360™.
              </p>
              <p data-id="element-35" data-mp="1f1187ep9lx6q">
                Not as another theory-heavy course. Not as another collection of
                disconnected lectures. But as a practical visual system of
                frameworks, decision maps, checklists, matrices, and educational
                cases designed to help dentists organize their occlusal analysis
                with greater clarity and consistency.
              </p>
            </div>

            <div className="mt-6 rounded-2xl border border-gold-500/40 bg-white p-5" data-id="element-36" data-mp="2zf1uqxld54c4">
              <p className="text-[12px] font-bold uppercase tracking-[0.12em] text-navy-700/60" data-id="element-37" data-mp="2uibdi6xto2p4">
                The goal is simple — help you move from…
              </p>
              <p className="mt-3 font-display text-[17px] font-bold italic text-clinical-red" data-id="element-38" data-mp="36zm8arr88cst">
                “I see a mark.”
              </p>
              <p className="mt-2 text-[12px] font-bold uppercase tracking-[0.12em] text-navy-700/50" data-id="element-39" data-mp="3br483chik7c7">
                to…
              </p>
              <p className="mt-2 font-display text-[17px] font-bold italic text-clinical-green" data-id="element-40" data-mp="2jzekkztdit1i">
                “I understand what I’m evaluating before I decide what to do.”
              </p>
            </div>
          </div>
        </div>

        <div className="mx-auto mt-9 w-full max-w-md" data-id="element-41" data-mp="2sz1mdmq0m0v3">
          <CTAButton label="I want Dr. Karito’s system" subline="Instant access · One-time payment of $27 USD" data-id="element-42" data-mp="2xz657jeeb7oh" />
        </div>
      </div>
    </section>;
}